
interface BusinessStatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isClosing: boolean;
  isLoading?: boolean;
}

export function BusinessStatusModal({ 
  isOpen, 
  onClose, 
  onConfirm, 
  isClosing,
  isLoading = false
}: BusinessStatusModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-white rounded-lg w-full max-w-sm p-6 shadow-xl">
        <div className="text-center">
          {/* 아이콘 */}
          <div className="w-16 h-16 mx-auto mb-4 bg-red-100 rounded-full flex items-center justify-center">
            <svg 
              className="w-8 h-8 text-red-600" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" 
              />
            </svg>
          </div>

          {/* 제목 */}
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            {isClosing ? '영업을 중단하시겠습니까?' : '영업을 시작하시겠습니까?'}
          </h3>

          {/* 메시지 */}
          <p className="text-sm text-gray-600 mb-6">
            {isClosing 
              ? '영업을 중단하면 고객이 주문할 수 없습니다. 정말 중단하시겠습니까?'
              : '영업을 시작하면 고객이 주문할 수 있습니다.'
            }
          </p>

          {/* 버튼들 */}
          <div className="flex gap-3">
            <button
              onClick={onClose}
              disabled={isLoading}
              className="flex-1 px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors disabled:opacity-50"
            >
              취소
            </button>
            <button
              onClick={onConfirm}
              disabled={isLoading}
              className={`flex-1 px-4 py-2 text-white rounded-lg transition-colors disabled:opacity-50 ${
                isClosing 
                  ? 'bg-red-500 hover:bg-red-600' 
                  : 'bg-green-500 hover:bg-green-600'
              }`}
            >
              {isLoading 
                ? (isClosing ? '중단 중...' : '시작 중...')
                : (isClosing ? '중단하기' : '시작하기')
              }
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}